import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  targetId: Constants.RegisterHash,
  values: {},
  
  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state,
}

const actions = {
	show ({commit}, {data}) {
    commit('setTargetId', data.locationUuid)

    let values = $.extend(true, {}, data)
    commit('setValues', values)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
    Vue.set(state.values, 'inpNickname', values.nickName)
    Vue.set(state.values, 'inpDisplay', values.display)
    Vue.set(state.values, 'inpFavorite', values.isFavorite === 1)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // updated
  setUpdated (state, flag) {
    state.updated = flag
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
